<template lang="html">
    <div class="childrenBox">
        <div class="children" v-for="childrenItem in childrenArr" :key="childrenItem.id">
            <div class="childrenFlex">
                <div class="checkBox">
                    <Checkbox
                        :disabled="disabledChecked || childrenItem.is_be_overdue === 1"
                        @click="checkboxChildrenChange({
                            baseItemCode,
                            childrenId: childrenItem.id,
                            is_be_overdue: childrenItem.is_be_overdue,
                            dataType
                        })"
                        v-model="childrenItem.is_selectd"
                        :checked-color="checkedColor">
                    </Checkbox>
                </div>
                <div class="goodsBox">
                    <div class="goodsImg" @click="toGoodsDetail(childrenItem)">
                        <!-- 抽奖标志 -->
                        <i class="isLuck ico ico-icon_65" v-if="childrenItem.is_lottery === 1"></i>
                        <QualityImg :src="childrenItem.img_url" width="140" height="140" />
                    </div>
                    <div class="goodsInfo">
                        <div @click="toGoodsDetail(childrenItem)" :class="{goodsName:true, goodsName100: !hasDel}">{{ childrenItem.sku_name }}</div>
                        <div class="goodsTag"  @click="toGoodsDetail(childrenItem)">
                            <span class="tag" v-if="childrenItem.goods_type === 'agent'">厂商直供</span>
                            <span class="tag" v-if="childrenItem.goods_type !== 'agent'">现货</span>
                            <span class="tag" v-if="childrenItem.exemption_from_postage === 1">包邮</span>
                            <span class="tag" v-if="childrenItem.is_fit === 1">适配</span>
                            <span class="tag" v-if="childrenItem.free_installation === 1">包安装</span>
                        </div>
                        <!-- 商品规格和计数器 -->
                        <div class="specAndstepper">
                            <div v-if="hasSpec" :style="{ visibility: childrenItem.spec === '' ? 'hidden': 'initial' }" :class="{goodsSpec: true, hideIcon: !isShowSelectIcon}" @click="onGoodsSkuChange({
                                baseItemCode,
                                dataType,
                                childrenId: childrenItem.id,
                                ...childrenItem
                            })">
                                <span>{{ childrenItem.spec }}</span>
                                <div class="icon" v-if="isShowSelectIcon">
                                    <van-icon name="arrow-down" color="#666666" class="header-arrow"/>
                                </div>
                            </div>
                            <div class="stepperBox" v-if="hasStepper">
                                <Stepper min="1" integer :max="childrenItem.stock_num < 99 ? childrenItem.stock_num : 99" @change="(value) => onChangeGoodsNumber({
                                    baseItemCode,
                                    childrenId: childrenItem.id,
                                    dataType,
                                    selected_num: value
                                })" theme="round" v-model="childrenItem.selected_num" button-size="24" />
                            </div>
                        </div>
                        <!-- 提示  -->
                        <div  v-if="childrenItem.sel_num > childrenItem.stock_num" class="tip">
                            所需数量{{childrenItem.sel_num}}，当前库存不足，可更换其他商品
                        </div>

                        <div class="priceBox"  @click="toGoodsDetail(childrenItem)">
                            <div class="priceLeft">
                                <!-- 是否折扣标志 -->
                                <i class="isDiscount ico ico-icon_64" v-if="childrenItem.is_service_plan === 1"></i>
                                <span class="price"><i class="flag">￥</i>{{ childrenItem.discount }}</span>
                                <span class="discountPrice" v-if="Number(childrenItem.price) !== 0">￥{{ childrenItem.price }}</span>
                            </div>

                            <div class="priceRight" v-if="hasGoodsNumber">
                                <span class="number">x {{ childrenItem.selected_num }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="childrenItem.free_installation === 1" class="tips">选中商品已包含安装服务费，如需其他服务，可自行选择</div>

            <!-- 操作按钮组（定位） -->
            <div class="goodsBtn">
                <a href="javascript:void(0)"
                    v-if="hasDel"
                    @click="onGoodsDel({
                    baseItemCode,
                    childrenId: childrenItem.id,
                    dataType})"
                    class="goodsDel">删除</a>

                <a href="javascript:void(0)"
                    v-if="hasChange"
                    @click="onGoodsChange({
                    baseItemCode,
                    childrenId: childrenItem.id,
                    dataType})" class="goodsChange">更换</a>
            </div>
        </div>
    </div>
</template>
<script>
import QualityImg from '@/components/qualityImg/qualityImg.vue'
import {
    Checkbox, Stepper
} from 'vant'

export default {
    name: 'itemProject',
    props: {
        /* 类型 */
        dataType: {
            type: String,
            default () {
                return 'goods'
            }
        },
        /* 保养项目编码：父组件唯一标识 */
        baseItemCode: {
            type: String,
            default () {
                return ''
            }
        },
        /* 子节点数据 */
        childrenArr: {
            type: Array,
            default () {
                return []
            }
        },
        /* 复选框选中颜色 */
        checkedColor:{
            type: String,
            default () {
                return '#fd3833'
            }
        },
        /* 是否禁止点击复选框 */
        disabledChecked: {
            type: Boolean,
            default () {
                return false
            }
        },
        /* 是否包含删除按钮 */
        hasDel: {
            type: Boolean,
            default () {
                return true
            }
        },
        /* 是否增加商品数量 */
        hasGoodsNumber: {
            type: Boolean,
            default () {
                return false
            }
        },
        /* 是否包含更改按钮 */
        hasChange: {
            type: Boolean,
            default () {
                return true
            }
        },
        /*
         * 是否显示下拉 icon
         */
        isShowSelectIcon: {
            type: Boolean,
            default () {
                return true
            }
        },
        /**
         * 是否显示计数器
         */
        hasStepper:{
            type: Boolean,
            default () {
                return true
            }
        },
        /**
         * 是否显示规格
         */
        hasSpec:{
            type: Boolean,
            default () {
                return true
            }
        },
    },
    components: {
        Checkbox,
        QualityImg,
        Stepper,
    },
    data () {
        return {
        }
    },
    methods:{
        /**
         * 改变复选框
         */
        checkboxChildrenChange (obj) {
            if (!(this.disabledChecked || obj.is_be_overdue === 1)) {
                this.$emit('checkboxChildrenChange', obj)
            }
        },
        /**
         * 删除商品
         */
        onGoodsDel (obj) {
            this.$emit('onGoodsDel', obj)
        },
        /**
         * 更换商品
         */
        onGoodsChange (obj) {
            this.$emit('onGoodsChange', obj)
        },
        /**
         * 改变商品数量
         */
        onChangeGoodsNumber (obj) {
            this.$emit('onChangeGoodsNumber', obj)
        },
        /**
         * 切换商品规格
         */
        onGoodsSkuChange (obj) {
            this.$emit('onGoodsSkuChange', obj)
        },
        /*
         * 跳转商品详情
         */
        toGoodsDetail (obj) {
            this.$emit('toGoodsDetail', obj)
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/stylus/variables.styl'
@import '~@/assets/stylus/mixin.styl'
/* 修改 vant的默认样式 */
.van-checkbox__icon--disabled.van-checkbox__icon--checked
        .van-icon
            color #ffffff
.van-checkbox__icon--disabled
        .van-icon
            border-color #999999
            background #999999
            color #ffffff
.van-stepper
        border-radius 6px
        border 1PX solid #c8c8c8
        box-sizing border-box
        button
            background #ffffff
        input
            border-left 1px solid #c8c8c8
            border-right 1px solid #c8c8c8
            border-top none
            border-bottom none
            background #ffffff
            margin 0
            width 70px
.childrenBox
    .children
        padding 30px 0
        position relative
        border-bottom 1px solid #efefef
        .childrenFlex
            display flex
        .goodsBtn
            position absolute
            top 40px
            right 30px
            .goodsDel
                font-size 23px
                line-height 23px
                color #666666
                display block
                margin-bottom 36px
            .goodsChange
                display block
                font-size 23px
                line-height 23px
                color #ff6600
        .checkBox
            width 106px
            display flex
            justify-content center
            align-items start
            padding-top 50px
        .goodsBox
            flex 1
            display flex
            .goodsImg
                width 140px
                height 140px
                margin-right 20px
                position relative
                img
                    width 140px
                    height 140px
                .isLuck
                    position absolute
                    top 0
                    left 0
                    z-index 10
            .goodsInfo
                flex 1
                .goodsName
                    margin-right 130px
                    min-height 72px;
                    font-size 24px
                    line-height 36px
                    color #666666
                    mutiLineTextOverFlow()
                .goodsName100
                    margin-right 30px
                .goodsTag
                    line-height 0
                    // margin-right 130px
                    box-sizing border-box
                    margin 36px 100px 36px 0
                    .tag
                        color #fc2d2d
                        padding 6px 10px
                        border-radius 14px
                        border 1px solid #fc2d2d
                        margin-right 14px
                        font-size 20px
                        text-align center
                .specAndstepper
                    display flex
                    .goodsSpec
                        width 270px
                        textOverflow()
                        height 54px
                        box-sizing border-box
                        line-height 54px
                        background-color #eeeeee
                        border-radius 6px
                        font-size 24px
                        color #3b3b3b
                        padding 0 54px 0 20px
                        position relative
                        margin-bottom 28px
                        .icon
                            position absolute
                            top 0
                            right 0
                            text-align center
                            height 54px
                            width 54px
                    .stepperBox
                        margin-left 20px
                        display inline-block
                .tip
                    margin 24px 0
                    color $fcRed
                    font-size $fontLeastSmall
                    .hideIcon
                        padding 0 20px
                .priceBox
                    display flex
                    align-content center
                    justify-content space-between
                    margin-right 30px
                    .priceLeft
                        .isDiscount
                            margin-right 2px
                        .price
                            font-size 30px
                            line-height 30px
                            color #fc2d2d
                            .flag
                                font-size 24px
                                font-style normal
                        .discountPrice
                            font-size 24px
                            line-height 30px
                            color #999999
                            text-decoration line-through
                            margin 0 20px
                    .priceRight
                        .number
                            font-size 23px
                            line-height 23px
                            color #666666
        .tips
            font-size 22px
            line-height 33px
            margin-top 20px
            color #666666
            display block
            width 100%
            text-align center
</style>
